import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import BackSubheader from 'src/components/elements/BackSubheader';
import React from 'react';
import {SendSnackDescriberData} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import Util from 'src/Util';
import AccountStore from 'src/stores/AccountStore';
import SnackDetailsRedesign from 'src/components/img/svg/SnackDetailsRedesign';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import AVText from 'src/components/elements/AVText';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {Platform} from 'react-native';
import {WithGlobalizeProps} from 'react-native-globalize';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

export function getBackSubHeaderDescriptor(): JSX.Element {
  return <BackSubheader title="" />;
}

export function renderSnackMsgDescriptor(
  props: SendSnackDescriberData & WithGlobalizeProps,
): string | string[] {
  const {amount, senderName} = props;
  const str = Localized.Labels.you_have_received_a_snack;
  return Localized.Labels.formatString(
    str,
    Util.formatCurrency(props, amount, AccountStore.getCurrency()),
    senderName,
  );
}
const getSenderTitle = (_props) => {
  return ['e', 'c'].indexOf(_props.status.toLowerCase()) > -1
    ? Localized.Labels.my_account
    : Localized.Labels.your_snack_sent;
};
export function getTopHeaderSnackDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  return (
    <React.Fragment>
      <SnackDetailsRedesign />
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        style={getSendSnackStyleDescriptor().appTitleStyle}
        accessible
        testID="qa_SendSnackType_txt"
        nativeID="qa_SendSnackType_txt"
      >
        {props.isSender
          ? getSenderTitle(props)
          : Localized.Labels.formatString(
              Localized.Labels.sent_you_snack_desc,
              props.senderName,
            )}
      </AVText>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        style={getSendSnackStyleDescriptor().dateStyle}
        accessible
        testID="qa_SendSnackTime_txt"
        nativeID="qa_SendSnackTime_txt"
      >
        {props.snackDate}
      </AVText>
    </React.Fragment>
  );
}

export function getSnackStickerDescriptor(): JSX.Element {
  return null;
}

export function snackErrorTextDescriptor() {
  return Localized.Errors.one_time_snack_365Pay_error_desc;
}

export function titleDescriptor(): string | string[] {
  return Localized.Labels.send_a_snack_title;
}
export function snackDetailsBtnFontSTyle() {
  return {fontFamily: Styles.FontFamily.aeonikRegular};
}
export function referralSummaryBtnTextFont() {
  return {
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: getLayoutDescriber().bodyFontSize(),
  };
}

export function backHeaderStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    backgroundColor:
      Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor,
  };
}
export function getBlockUserBtn({onBlockUser}) {
  return (
    <RoundedButton
      buttonType={ButtonType.outline}
      text={Localized.Buttons.block_user}
      containerStyle={getSendSnackStyleDescriptor().btnBlockUser}
      backgroundColor={blockUnblockButtonColor()}
      color={Styles.dangerColor}
      onPress={onBlockUser}
      accessibilityLabel="Block Snack User"
      textStyle={[
        {textAlign: 'center'},
        getSendSnackStyleDescriptor().btnBlockUserText,
      ]}
      accessible
      testID="qa_BlockUser_btn"
    />
  );
}
export function getUnBlockUserBtn({onUnBlockUser}) {
  return (
    <RoundedButton
      buttonType={unblockButtonType()}
      text={Localized.Labels.unblock_user}
      backgroundColor={blockUnblockButtonColor()}
      containerStyle={getSendSnackStyleDescriptor().btnBlockUser}
      color={Styles.dangerColor}
      accessibilityLabel="Blocked"
      textStyle={getSendSnackStyleDescriptor().btnBlockUserText}
      onPress={onUnBlockUser}
      accessible
      testID="qa_UnblockUser_btn"
      nativeID="qa_UnblockUser_btn"
    />
  );
}
export function getAcceptSnackButton({
  acceptSnack,
  snackDetails,
  context,
  isAcceptButtonVisible,
}) {
  return (
    isAcceptButtonVisible && (
      <RoundedButton
        accessibilityLabel="Accept Snack"
        buttonType={ButtonType.action}
        color={acceptButtonColor()}
        text={Localized.Buttons.accept_snack}
        textStyle={getSendSnackStyleDescriptor().btnAccept}
        onPress={() =>
          acceptSnack({
            snackDetails,
            context,
          })
        }
      />
    )
  );
}

export function unblockButtonType() {
  return ButtonType.outline;
}
export function acceptButtonColor() {
  return Styles.Colors.PayNew.primary01;
}
export function blockUnblockButtonColor() {
  return Styles.white;
}

export function getAcceptSnackBtn(props, appContext) {
  return (
    <RoundedAppButton
      accessibilityLabelValue="Accept Snack"
      buttonType={RoundedAppButtonType.Solid}
      titleText={Localized.Buttons.accept_snack_redesign}
      onPress={() =>
        props.acceptSnack({
          snackDetails: props.snackDetails,
          context: appContext,
        })
      }
      buttonContainerStyle={{
        alignSelf: 'flex-end',
        marginRight: Styles.Spacing.m3,
        marginBottom: Styles.Spacing.m3,
      }}
    />
  );
}

export function blockUserBtnStyle() {
  return Styles.white;
}

export function getSendSnackStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    errorContainerColor: {
      backgroundColor: 'rgba(215, 38, 61, 0.15)',
    },
    topRow: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      marginBottom: Styles.Spacing.m3,
    },
    content: {
      padding: Styles.Spacing.m3 + Styles.Spacing.m2,
      flex: 1,
      backgroundColor:
        Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor,
    },
    senderSnackStatusText: {
      color: Styles.black,
      flex: 1,
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    appTitleStyle: {
      color: Styles.black,
      fontSize: Styles.Fonts.sectionHeader,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
      flex: 1,
    },
    dateStyle: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.aeonikRegular,
      top: 2,
    },
    description: {
      flex: 1,
      marginTop: Styles.Spacing.m1,
      color: Styles.black,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    message: {
      color: Styles.black,
      flex: 1,
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    receiverSnackStatusText: {
      flex: 1,
      textAlign: 'center',
      color: Styles.black,
      fontSize: Styles.Fonts.f7,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    amount: {
      color: Styles.black,
      fontSize: Styles.Fonts.f11 + 8,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    btnBlockUser: {
      marginTop: Styles.Spacing.m3,
      paddingVertical: 8,
      paddingHorizontal: 18,
      borderWidth: 2,
      alignSelf: 'center',
    },
    btnBlockUserText: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    btnAcceptSnack: {
      paddingVertical: 8,
      paddingHorizontal: 18,
    },
    blockUserHeaderText: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
      marginBottom: Styles.Spacing.m2,
    },
    blockUserHeaderTextDesc: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    btnAccept: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    scrollViewContent: {
      flexGrow: 1,
      paddingBottom: Styles.Spacing.m5 + Styles.Spacing.m4,
    },
  };
}

export function snackMessageContainerStyle() {
  return {
    maxHeight: 130,
    minHeight: 130,
  };
}

export function snackMessageContentStyle() {
  return {
    paddingTop: Styles.Spacing.m2,
    paddingBottom:
      Platform.OS === 'ios' ? Styles.Spacing.m4 * 3 : Styles.Spacing.m4,
  };
}

export default {
  getBackSubHeaderDescriptor,
  getTopHeaderSnackDescriptor,
  getSnackStickerDescriptor,
  renderSnackMsgDescriptor,
  getSendSnackStyleDescriptor,
  getAcceptSnackBtn,
  blockUserBtnStyle,
  backHeaderStyleDescriptor,
  unblockButtonType,
  titleDescriptor,
  referralSummaryBtnTextFont,
  blockUnblockButtonColor,
  getBlockUserBtn,
  snackErrorTextDescriptor,
  acceptButtonColor,
  snackDetailsBtnFontSTyle,
  snackMessageContainerStyle,
  snackMessageContentStyle,
  getUnBlockUserBtn,
  getAcceptSnackButton,
};
